import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
//  import profileImage from "profile.png";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useRef } from "react";
import useSWR from "swr";


const OrderDetail = ({ expanded }) => {
    // const [lead, setLead] = useState(null);
    const { id } = useParams();
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const module = "Script";
    const [selectedRelatedList, setSelectedRelatedList] = useState(null);
    const [calls, setCalls] = useState([])



    const notesRef = useRef(null);

    const handleRelatedListClick = (name) => {
        setSelectedRelatedList(name);

        if (name === "Notes" && notesRef.current) {
            notesRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };



    const idToFetch = id;

    // useEffect(() => {
    //     const fetchLeadData = async () => {
    //         setLoading(true);
    //         try {
    //             const response = await fetch(`/server/dealer_backend/getSpecificScript?id=${idToFetch}`); // Replace with actual backend URL
    //             const data = await response.json();
    //             // console.log(data);

    //             if (data.status === "success") {
    //                 const filteredLead = data.data.find((item) => item.id === idToFetch);
    //                 setLead(data.data[0]);
    //             } else {
    //                 // console.error("Error fetching data:", data.error);
    //             }
    //         } catch (error) {
    //             // console.error("Failed to fetch lead data:", error);
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchLeadData();
    // }, []);



    const fetcher = url => fetch(url).then(res => res.json());

    const { data, error, isLoading } = useSWR(
        idToFetch ? `/server/dealer_backend/getSpecificScript?id=${idToFetch}` : null,
        fetcher
    );

    // Extract the lead data once response is loaded and status is success
    const lead = data?.status === "success"
        ? data.data.find(item => item.id === idToFetch) || data.data[0]
        : null;



    const [notesData, setNotesData] = useState([]);
    const [statusData, setStatusData] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [emails, setEmails] = useState([]);
    const [payments, setPayments] = useState([]);




    const fetchNotes = async () => {
        try {
            const res = await fetch(`/server/dealer_backend/getNotes?module=${module}&recordId=${idToFetch}`);
            const json = await res.json();

            if (json.status === "success") {
                const sortedNotes = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));
                setNotesData(sortedNotes);
            } else {
                // console.error("Error fetching notes:", json.error);
            }
        } catch (err) {
            // console.error("Network error:", err);
        }
    };



    const fetchAttachments = async () => {
        try {

            const res = await fetch(`/server/dealer_backend/getAttachments?module=${module}&recordId=${idToFetch}`);
            const json = await res.json();



            if (json.status === "success") {
                const sortedAttachments = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

                setAttachments(sortedAttachments);

            } else {
                // console.error("Error fetching attachments:", json.error);
            }
        } catch (err) {
            // console.error("Network error:", err);
        }
    };


    const fetchStatus = async () => {
        try {

            const res = await fetch(`/server/dealer_backend/getStatus?module=${module}&recordId=${idToFetch}`);
            const json = await res.json();

            // console.log(json)

            if (json.status === "success") {
                const sortedStatus = json.data.sort((a, b) => new Date(b.Modified_Time) - new Date(a.Modified_Time));
                setStatusData(sortedStatus);

            } else {
                // console.error("Error fetching status:", json.error);
            }
        } catch (err) {
            // console.error("Network error:", err);
        }
    };


    const fetchEmails = async () => {
        try {

            const res = await fetch(`/server/dealer_backend/getEmails?module=${module}&recordId=${idToFetch}`);
            const json = await res.json();

            // console.log(json)



            if (json.status === "success") {
                const sortedEmails = json.data.sort((a, b) => new Date(b.time) - new Date(a.time));
                setEmails(sortedEmails);

            } else {
                // console.error("Error fetching emails:", json.error);
            }
        } catch (err) {
            // console.error("Network error:", err);
        }
    };


    const fetchPayments = async () => {
        try {

            const res = await fetch(`/server/dealer_backend/getPayments?module=${module}&recordId=${idToFetch}`);
            const json = await res.json();

            // console.log(json)



            if (json.status === "success") {
                const sortedPayments = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

                setPayments(sortedPayments);

            } else {
                // console.error("Error fetching payments:", json.error);
            }
        } catch (err) {
            // console.error("Network error:", err);
        }
    };


    const fetchManualCalls = async () => {
        try {

            const res = await fetch(`/server/dealer_backend/getManualCalls?module=${module}&recordId=${idToFetch}`);
            const json = await res.json();

            // console.log(json)



            if (json.status === "success") {
                const sortedCalls = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

                setCalls(sortedCalls);

            } else {
                // console.error("Error fetching payments:", json.error);
            }
        } catch (err) {
            // console.error("Network error:", err);
        }
    };

    useEffect(() => {
        fetchNotes();
        // fetchStatus();
        fetchAttachments();
        fetchEmails();
        // fetchPayments();
        // fetchManualCalls()

    }, [idToFetch])




    const LeadField = ({ label, value, icon }) => (
        <div className="form-group-field2">
            <label>{label}</label>
            <span>
                {icon && <span className="icon">{icon}</span>}
                {value || "—"}
            </span>
        </div>
    );



    const formatSize = (bytes) => {
        if (!bytes) return "—";
        const kb = bytes / 1024;
        return kb < 1024
            ? `${kb.toFixed(1)} KB`
            : `${(kb / 1024).toFixed(2)} MB`;
    };




    const formatDate = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };



    const [relatedLists, setRelatedLists] = useState([]);

    useEffect(() => {
        const fetchRelatedLists = async () => {

            try {
                const response = await fetch(`/server/dealer_backend/getRelatedLists?module=${module}`);
                const data = await response.json();
                // console.log(data);

                if (data.status === "success") {
                    setRelatedLists(data.related_lists);
                } else {
                    // console.error("Failed to fetch transitions:", data.message);
                }
            } catch (err) {
                // console.error("Failed to fetch related lists:", err);
            }
        };

        fetchRelatedLists();
    }, [module]);





    return (

        isLoading ? (
            <div className="loading-circle flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
            </div>
        ) : (
            <React.Fragment>
                <header style={{
                    position: 'fixed',
                    top: 0,
                    left: expanded ? '5rem' : '16rem',
                    right: 0,
                    height: '5rem',
                    backgroundColor: 'white',
                    zIndex: 1000,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '1rem',
                    borderBottom: '1px solid #e5e7eb',
                }} className="header-fixed mobile-header bg-white  border-b px-6 py-4 flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                        {/* <button className="text-gray-600 hover:text-black text-lg">←</button> */}
                        <button
                            className="text-gray-600 hover:text-black text-lg"
                            onClick={() => {
                                if (window.history.length > 1) {
                                    navigate(-1);
                                } else {
                                    navigate(`/script`);
                                }
                            }}
                            aria-label="Go back"
                        >
                            <ArrowLeft />
                        </button>



                        <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-lg">
                            {(lead?.Name?.charAt(0)?.toUpperCase()) || ''}
                        </div>

                        <h1 className="text-xl font-semibold">{lead?.Name || ''}</h1>

                    </div>

                </header>
                <div className="flex">
                
                    <main style={{
                        // marginTop: '4rem',
                        // marginLeft: '14rem',
                        // height: 'calc(100vh - 4rem)',
                        // overflowY: 'auto',
                        padding: '1rem',
                        flexGrow: 1,
                    }}>
                        <div className="ml-[-2rem] script-maindiv  lead-container p-4 flex-1">

                            {/* Lead Status Card */}











                            {/* Lead Information Card */}



                            <div className="lead-container2">
                                <h3 className="lead-title">Script Information</h3>
                                <hr className="lead-divider" />
                                {lead && (
                                    <div className="table-mobile  md:grid-cols-2 gap-6 text-sm text-gray-700 break-words ml-[-21rem]">
                                        {/* Left Column */}
                                        <div className="space-y-3">
                                            <LeadField label="Script Document Name" value={lead?.Name || "—"} />

                                            <LeadField
                                                label="Script Description"
                                                value={
                                                    lead?.Script_Description ? (
                                                        <div className="whitespace-pre-line break-words text-sm max-h-[33rem] overflow-auto">
                                                            {
                                                                lead.Script_Description
                                                                    .split("\n")
                                                                    .map((line, index) => <p key={index}>{line}</p>)
                                                            }
                                                            <div className="text-xs text-gray-500 mt-2 italic">
                                                                {/* Total lines: {lead.Script_Description.split("\n").length} */}
                                                            </div>
                                                        </div>
                                                    ) : "—"
                                                }
                                            />

                                        </div>

                                        {/* Right Column */}
                                        <div className="space-y-3">
                                            {/* <LeadField label="Script Owner" value={lead?.Script_Owner || "—"} /> */}

                                            {/* <LeadField
                                                label="Created By"
                                                value={
                                                    <div>
                                                        <div>{}</div>
                                                        <div className="text-gray-500 text-xs mt-1">
                                                            {lead?.Created_Time
                                                                ? new Date(lead.Created_Time).toLocaleString("en-IN", {
                                                                    weekday: "short",
                                                                    day: "2-digit",
                                                                    month: "short",
                                                                    year: "numeric",
                                                                    hour: "2-digit",
                                                                    minute: "2-digit",
                                                                })
                                                                : "—"}
                                                        </div>
                                                    </div>
                                                }
                                            /> */}

                                            {/* <LeadField
                                                label="Modified Time"
                                                value={
                                                    <div>
                                                        <div>{lead?.Modified_By || "—"}</div>
                                                        <div className="text-gray-500 text-xs mt-1">
                                                            {lead?.Modified_Time
                                                                ? new Date(lead.Modified_Time).toLocaleString("en-IN", {
                                                                    weekday: "short",
                                                                    day: "2-digit",
                                                                    month: "short",
                                                                    year: "numeric",
                                                                    hour: "2-digit",
                                                                    minute: "2-digit",
                                                                })
                                                                : "—"}
                                                        </div>
                                                    </div>
                                                }
                                            /> */}
                                        </div>
                                    </div>
                                )}
                            </div>


{/* 


                            <div id="notes" className="lead-container2">
                                <h3 className="text-xl font-semibold mb-4">Notes</h3>

                                {notesData.map((note, idx) => (
                                    <div
                                        key={idx}
                                        className="border rounded-lg p-4 bg-gray-50 mb-4"
                                    >
                                        <div className="flex items-start space-x-3">
                                            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-xl">
                                                <span>📝</span>
                                            </div>
                                            <div className="flex-1">
                                                <div className="text-sm font-semibold">{note.Note_Content || "—"}</div>
                                                <div className="text-xs text-gray-600 mb-1">
                                                    Potential Donor -{" "}
                                                    <span className="text-blue-600">
                                                        {note.Parent_Id?.name || "—"}
                                                    </span>{" "}
                                                    • <span>now</span> by{" "}
                                                    <span className="text-blue-600">
                                                        {note.Owner?.name || "—"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div> */}






{/* 
                            <div id="email" className="lead-container2">
                                <h3 className="text-lg font-semibold mb-3">Emails</h3>
                                <div className="overflow-x-auto">
                                    <table className="min-w-full text-sm border-collapse">
                                        <thead>
                                            <tr className="border-b bg-gray-50 text-left">
                                                <th className="py-2 px-3">Subject</th>
                                                <th className="py-2 px-3">Date</th>
                                                <th className="py-2 px-3">Source</th>
                                                <th className="py-2 px-3">Sent By</th>
                                                <th className="py-2 px-3">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {emails.map((email, idx) => (
                                                <tr key={idx} className="border-t">
                                                    <td className="py-2 px-3">{email.subject || "—"}</td>
                                                    <td className="py-2 px-3">{email.time ? formatDate(email.time) : "—"}</td>
                                                    <td className="py-2 px-3">{email.Source || "—"}</td>
                                                    <td className="py-2 px-3">{email.from.user_name || "—"}</td>
                                                    <td className="py-2 px-3">{email.status[0].type || "—"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div> */}










                        </div>

                    </main>

                </div>
            </React.Fragment>
        )


    );
};

export default OrderDetail;
